<template>
    <div id="editQuestionLoadingDiv" class="vs-con-loading__container">
        <div id="module-data">
            <vx-card class="mb-base" style="min-height: 600px;">
                <form data-vv-scope="addQuestionForm">

                    <div class="vx-row mb-base">
                        <div class="vx-col w-12/12 mb-2">
                            Language
                            <vs-switch class="w-full" color="success" v-model="lang">
                                <span slot="on">English</span>
                                <span slot="off">Danish</span>
                            </vs-switch>
                        </div>
                    </div>
                    <div class="vx-row mb-base">

                        <div class="vx-col w-12/12 mb-2">
                            <croppa key="2" :width="500" :height="350" placeholder="Choose image" :placeholder-font-size="16"
                                :prevent-white-space="true" v-model="myCroppa"></croppa>
                            <!-- <span class="text-danger text-sm" v-show="errors.has('addQuestionForm.picture')">{{
                                errors.first('addQuestionForm.picture') }}</span> -->
                        </div>

                    </div>

                    <vs-divider position="left"> Categories </vs-divider>

                    <div class="flex flex-wrap items-center justify-end vx-row mb-2 mb-base">
                        <div class="vx-col w-full mb-2">
                            <treeselect v-model="question_data.categories" :multiple="true"
                                :options="question_categories_options" />
                        </div>
                    </div>

                    <vs-divider />

                    <div class="vx-row mb-base">
                        <div class="vx-col sm:w-3/4">
                            Situation
                            <vs-textarea height="200" v-validate="'required'" name="situation" ref="situation"
                                v-model="question_data.situation" />
                            <span class="text-danger text-sm" v-show="errors.has('addQuestionForm.situation')">{{
                                errors.first('addQuestionForm.situation') }}</span>
                        </div>
                        <div class="vx-col sm:w-1/4" v-if="question_data.situation_audio">
                            <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                :audio-list="[question_data.situation_audio]" theme-color="#00A99D" />
                        </div>
                    </div>

                    <vs-divider />

                    <vs-tabs>
                        <vs-tab label="Question 1">
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-7/12">
                                    <vs-textarea height="200" v-validate="'max:500'" name="q1" ref="q1"
                                        v-model="question_data.q1" />
                                    <span class="text-danger text-sm" v-show="errors.has('addQuestionForm.q1')">{{
                                        errors.first('addQuestionForm.q1') }}</span>
                                </div>
                                <div class="vx-col sm:w-2/12">
                                    Correct answer
                                    <vs-switch color="success" v-model="a1">
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                    </vs-switch>
                                </div>
                                <div class="vx-col sm:w-3/12" v-if="question_data.q1_audio">
                                    <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                        :audio-list="[question_data.q1_audio]" theme-color="#00A99D" />
                                </div>
                            </div>
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-full">
                                    Explanation
                                    <quill-editor v-model="question_data.q1_explanation"></quill-editor>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Question 2">
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-7/12">
                                    <vs-textarea height="200" v-validate="'max:500'" name="q2" ref="q2"
                                        v-model="question_data.q2" />
                                    <span class="text-danger text-sm" v-show="errors.has('addQuestionForm.q2')">{{
                                        errors.first('addQuestionForm.q2') }}</span>
                                </div>
                                <div class="vx-col sm:w-2/12">
                                    Correct answer
                                    <vs-switch color="success" v-model="a2">
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                    </vs-switch>
                                </div>
                                <div class="vx-col sm:w-3/12" v-if="question_data.q2_audio">
                                    <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                        :audio-list="[question_data.q2_audio]" theme-color="#00A99D" />
                                </div>
                            </div>
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-full">
                                    Explanation
                                    <quill-editor v-model="question_data.q2_explanation"></quill-editor>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Question 3">
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-7/12">
                                    <vs-textarea height="200" v-validate="'max:500'" name="q3" ref="q3"
                                        v-model="question_data.q3" />
                                    <span class="text-danger text-sm" v-show="errors.has('addQuestionForm.q3')">{{
                                        errors.first('addQuestionForm.q3') }}</span>
                                </div>
                                <div class="vx-col sm:w-2/12">
                                    Correct answer
                                    <vs-switch color="success" v-model="a3">
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                    </vs-switch>
                                </div>
                                <div class="vx-col sm:w-3/12" v-if="question_data.q3_audio">
                                    <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                        :audio-list="[question_data.q3_audio]" theme-color="#00A99D" />
                                </div>
                            </div>
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-full">
                                    Explanation
                                    <quill-editor v-model="question_data.q3_explanation"></quill-editor>
                                </div>
                            </div>
                        </vs-tab>
                        <vs-tab label="Question 4">
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-7/12">
                                    <vs-textarea height="200" v-validate="'max:500'" name="q4" ref="q4"
                                        v-model="question_data.q4" />
                                    <span class="text-danger text-sm" v-show="errors.has('addQuestionForm.q4')">{{
                                        errors.first('addQuestionForm.q4') }}</span>
                                </div>
                                <div class="vx-col sm:w-2/12">
                                    Correct answer
                                    <vs-switch color="success" v-model="a4">
                                        <span slot="on">Yes</span>
                                        <span slot="off">No</span>
                                    </vs-switch>
                                </div>
                                <div class="vx-col sm:w-3/12" v-if="question_data.q4_audio">
                                    <audio-player ref="audioPlayer" :show-playback-rate="false" :isLoop="false"
                                        :audio-list="[question_data.q4_audio]" theme-color="#00A99D" />
                                </div>
                            </div>
                            <div class="vx-row mt-4">
                                <div class="vx-col sm:w-full">
                                    Explanation
                                    <quill-editor v-model="question_data.q4_explanation"></quill-editor>
                                </div>
                            </div>
                        </vs-tab>
                    </vs-tabs>

                    <vs-divider />

                    <div class="vx-row mt-base">
                        <div class="vx-col w-full" align="right">
                            <vs-button @click="validateAddQuestion()" class="mr-3 mb-2">Create Question</vs-button>
                        </div>
                    </div>
                </form>
            </vx-card>
        </div>
    </div>
</template>

<script>
import moduleQuestionManagement from '@/store/question-management/moduleQuestionManagement.js'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Vue from 'vue'
import 'vue-croppa/dist/vue-croppa.css'
import Croppa from 'vue-croppa'

Vue.use(Croppa) 

export default {
    data() {
        return {
            myCroppa: {},
            lastPage: '',
            question_data: {
                lang: "en",
                situation: "",
                categories: [],

                q1: "",
                a1: "true",
                q1_explanation: "",

                q2: "",
                a2: "true",
                q2_explanation: "",

                q3: "",
                a3: "true",
                q3_explanation: "",

                q4: "",
                a4: "true",
                q4_explanation: "",
            },
            file: [],
            fileRecordsForUpload: [],
          
            question_not_found: false,
        }
    },
    components: {
        quillEditor,
        Treeselect,
    },
    computed: {
        question_categories_options() {
            let categories = this.$store.state.questionManagement.categories
            let categoriesData = []

            categories.forEach(function (entry, key) {
                categoriesData.push({
                    id: entry.id,
                    title: entry.name,
                    label: entry.name,
                })
            });

            return categoriesData
        },
        lang: {
            set: function (val) {
                this.question_data.lang = val ? "en" : "da";
            },
            get: function () {
                return this.question_data.lang == "en" ? true : false;
            }
        },
        a1: {
            set: function (val) {
                this.question_data.a1 = val ? "true" : "false";
            },
            get: function () {
                return this.question_data.a1 == "true" ? true : false;
            }
        },
        a2: {
            set: function (val) {
                this.question_data.a2 = val ? "true" : "false";
            },
            get: function () {
                return this.question_data.a2 == "true" ? true : false;
            }
        },
        a3: {
            set: function (val) {
                this.question_data.a3 = val ? "true" : "false";
            },
            get: function () {
                return this.question_data.a3 == "true" ? true : false;
            }
        },
        a4: {
            set: function (val) {
                this.question_data.a4 = val ? "true" : "false";
            },
            get: function () {
                return this.question_data.a4 == "true" ? true : false;
            }
        },
    },
    methods: {
        getAllQuestions() {
            console.log('getting questions');


            this.$store.dispatch("questionManagement/getAllQuestions")
                .then(res => {
                    console.log(res.data);
                    // this.questionsData = res.data.data
                    // this.totalPage = res.data.last_page
                    // this.$vs.loading.close('#allQuestionsLoadingDiv > .con-vs-loading')
                    localStorage.setItem('lastPage', res.data.last_page);
                    // this.lastPage = res.data.last_page

                    console.log('im ques fetcher : ', this.currentPage);
                })
                .catch(err => {
                    // this.$vs.loading.close('#allQuestionsLoadingDiv > .con-vs-loading')
                })
        },
        filesSelected: function (fileRecordsNewlySelected) {
            var validFileRecords = fileRecordsNewlySelected.filter((fileRecord) => !fileRecord.error);
            this.fileRecordsForUpload = this.fileRecordsForUpload.concat(validFileRecords);
        },
        onBeforeDelete: function (fileRecord) {
            // this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            var i = this.fileRecordsForUpload.indexOf(fileRecord);
            if (i !== -1) {
                // queued file, not yet uploaded. Just remove from the arrays
                this.fileRecordsForUpload.splice(i, 1);
                var k = this.file.indexOf(fileRecord);
                if (k !== -1) this.file.splice(k, 1);
            } else {
                this.$refs.vueFileAgent.deleteFileRecord(fileRecord);
            }
        },
        fileDeleted: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(fileRecord);
            // var i = this.fileRecordsForUpload.indexOf(fileRecord);
            // if (i !== -1) {
            //     this.fileRecordsForUpload.splice(i, 1);
            // } else {
            //     this.deleteUploadedFile(fileRecord);
            // }
        },
        deleteUploadedFile: function (fileRecord) {
            this.$refs.vueFileAgent.deleteUpload(this.uploadUrl, this.uploadHeaders, fileRecord);
        },
        redirectToAllPackages() {
            this.$router.push("/packages").catch(() => { })
        },
        validateAddQuestion() {
            this.$validator.validateAll('addQuestionForm').then(result => {
                if (result) this.updateQuestion()
            })
        },

        async updateQuestion() {
            var self = this

            this.$vs.loading({
                container: '#editQuestionLoadingDiv',
                scale: 0.6
            })

            let questionData = new FormData();
            questionData.append('id', this.question_data.id);
            questionData.append('question_id', this.question_data.id);

            questionData.append('lang', this.question_data.lang);
            questionData.append('situation', this.question_data.situation);

            questionData.append('q1', this.question_data.q1);
            questionData.append('a1', this.question_data.a1);
            questionData.append('q1_explanation', this.question_data.q1_explanation);

            questionData.append('q2', this.question_data.q2);
            questionData.append('a2', this.question_data.a2);
            questionData.append('q2_explanation', this.question_data.q2_explanation);

            questionData.append('q3', this.question_data.q3);
            questionData.append('a3', this.question_data.a3);
            questionData.append('q3_explanation', this.question_data.q3_explanation);

            questionData.append('q4', this.question_data.q4);
            questionData.append('a4', this.question_data.a4);
            questionData.append('q4_explanation', this.question_data.q4_explanation);

            if (this.question_data.categories.length) {
                for (let i = 0; i < this.question_data.categories.length; i++) {
                    questionData.append('categories[]', this.question_data.categories[i]);
                }
            }

            // croppa image add

            const blob = await this.myCroppa.promisedBlob()
            if (this.myCroppa.hasImage()) questionData.append('picture', blob);

            for (var pair of questionData.entries()) {
                console.log(pair[0] + ', ' + pair[1]);
            }




            this.$store.dispatch("questionManagement/createQuestion", questionData)
                .then(res => {
                    this.question_data = res.data.data
                    this.$vs.loading.close('#editQuestionLoadingDiv > .con-vs-loading')

                    this.$vs.notify({
                        time: 4000,
                        title: 'Success',
                        text: 'Sussfully Updated.',
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle'
                    });
                    var lstPg = localStorage.getItem('lastPage');
                    localStorage.setItem('currentPage', lstPg);
                    this.$router.push("/questions").catch(() => { })
                    // this.$router.push("/questions/edit/" + this.question_data.id).catch(() => {})
                })
                .catch(err => {
                    this.$vs.loading.close('#editQuestionLoadingDiv > .con-vs-loading')

                    if (err.status && err.status == 422) {
                        Object.keys(err.data).forEach(function (key) {
                            self.errors.add({
                                field: key,
                                msg: err.data[key][0],
                            });
                        });
                    }
                })
        },
    },
    async mounted() {
        await this.$store.dispatch("questionManagement/viewCategoryWithoutPaginate", { avoid_paginate: "true" })
        this.getAllQuestions();
    },
    created() {
        if (!moduleQuestionManagement.isRegistered) {
            this.$store.registerModule('questionManagement', moduleQuestionManagement)
            moduleQuestionManagement.isRegistered = true
        }

    },

}
</script>

<style type="text/css">
::-webkit-scrollbar {
    width: 0px;
    background: transparent;
}

.vs-con-textarea textarea {
    height: 200px;
}
</style>